import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ComputerAppsEffects } from 'mbs-ui-shared@modules/computer-apps/store/computer-apps.effects';
import { reducer } from 'mbs-ui-shared@modules/computer-apps/store/computer-apps.reducer';
import { FeatureKey } from 'mbs-ui-shared@modules/computer-apps/store/const';
import { ComputersAbstractService, ComputersService } from 'mbs-ui-shared@services/computers.service';
import { RmCommandsWrapper } from 'mbs-ui-shared@services/rm-commands.wrapper';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(FeatureKey, reducer), EffectsModule.forFeature([ComputerAppsEffects])],
  providers: [{ provide: ComputersAbstractService, useClass: ComputersService }, RmCommandsWrapper]
})
export class ComputerAppsModule {}
